module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ../~/symbol-observable/index.js
 ** module id = 272
 ** module chunks = 3
 **/